export default "__VITE_ASSET__CeefiAJ1__ 300w";